// src/components/form-error.ts
import { formErrorAnatomy as parts } from "@chakra-ui/anatomy";
import {
  createMultiStyleConfigHelpers,
  cssVar,
  defineStyle
} from "@chakra-ui/styled-system";
var { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
var $fg = cssVar("form-error-color");
var baseStyleText = defineStyle({
  [$fg.variable]: `colors.red.500`,
  _dark: {
    [$fg.variable]: `colors.red.300`
  },
  color: $fg.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
});
var baseStyleIcon = defineStyle({
  marginEnd: "0.5em",
  [$fg.variable]: `colors.red.500`,
  _dark: {
    [$fg.variable]: `colors.red.300`
  },
  color: $fg.reference
});
var baseStyle = definePartsStyle({
  text: baseStyleText,
  icon: baseStyleIcon
});
var formErrorTheme = defineMultiStyleConfig({
  baseStyle
});

export {
  formErrorTheme
};
//# sourceMappingURL=chunk-SRBDDT7F.mjs.map